import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { Import, importType } from "../../types/slices/importType";
import { RootState } from "../store";

const initialState:importType = {
    status: ApiStatus.FETCHED,
    imports: [],
    importSelected: {} as Import,
    errorMessage: undefined,
}

const importSlice = createSlice({
    name: 'importSlice',
    initialState,
    reducers: {
        onFetchImports (state, { payload }: { payload: Import[]}) {
            state.status = ApiStatus.FETCHED
            state.imports = payload
            state.errorMessage = undefined
        },
        onSetSelectedImport (state, { payload }: { payload: Import }) {
            state.importSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        }
    }
})

export const selectImportState = (state: RootState) => state.importSlice
export default importSlice.reducer
export const {
    onFetchImports,
    onSetSelectedImport,
    changeStatus
} = importSlice.actions